import { Modal, ModalFuncProps } from 'antd';

let defaults: ModalFuncProps = {};

export const setDefaults = (values: ModalFuncProps) => {
  defaults = values;
};

const appConfirm = (rest: ModalFuncProps) => {
  return Modal.confirm({
    ...defaults,
    ...rest
  });
};

export default appConfirm;
